import { render } from "./App.vue?vue&type=template&id=4cfb7048"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4cfb7048&lang=css"

import exportComponent from "D:\\Light-work-sprintoff\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__